import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import PropTypes from "prop-types";
import style from "./account.module.scss";

const AccountMenu = ({ name, route, isListTop = false }) => {
  const navigate = useNavigate();
  const menuClass = classNames(style.accountMenu, isListTop && style.listTop);

  const handleButtonClick = () => {
    if (route) {
      navigate(route);
    }
  };
  return (
    <div className={menuClass}>
      <span className={style.menuTitle}>{name}</span>
      <button className={style.button} onClick={handleButtonClick}>
        <i className="tg-icons-LeftArrow" />
      </button>
    </div>
  );
};

AccountMenu.propTypes = {
  name: PropTypes.string.isRequired,
  route: PropTypes.string.isRequired,
  isListTop: PropTypes.bool,
};

export default AccountMenu;
